import { iframeReplace } from 'core/iframe';
import { CONFIG } from 'config';
import { queryParam } from 'utils/query';

export function RankingStartup(props) {
    const param = queryParam('startupId');
    const search = window.location.search.replace('?', '&');

    // Check if the startupId is set to redirect to ranking
    let url2Redirect = `${CONFIG.appLinks.startup}?rankingRedirect=true${search}`;
    if (param) {
        url2Redirect = `${CONFIG.appLinks.startupRanking}?fromRanking=true${search}`;
    }

    // console.log('RankingStartup', iframeReplace('https://startup.openstartups.net'));
    iframeReplace(`${url2Redirect}`, '/ranking')();
    return null;
}
export default RankingStartup;
